var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}},[_c('path',{attrs:{"stroke":"#525D70","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.2","d":"M14 8H7.333M14 12H7.333M14 4H7.333M2 5.333 4.667 8 2 10.667"}})])
}
var staticRenderFns = []

export default { render: render }